import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../modules/modal/modal-ref";
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {modalSlideAnimation, scaleAnimation} from "../../../shared/utils/animations";
import {
  NotificationDialogComponent
} from "../../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {UserSubscription} from "../../../user/user-subscription";
import {Subject} from "rxjs";
import {CountPipe} from "../../../shared/pipes/count.pipe";
import {SizePipe} from "../../../shared/pipes/size.pipe";
import {Router} from "@angular/router";

@Component({
    selector: 'db-switch-plan',
    templateUrl: './switch-plan.component.html',
    styleUrls: ['./switch-plan.component.scss'],
    animations: [modalSlideAnimation, scaleAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SwitchPlanComponent implements OnInit, OnDestroy {

  @Input() switchToAnnual?: boolean;
  @Input() userSubscription: UserSubscription;
  @Input() annualSubscription: UserSubscription;
  @Input() monthlyPrice?: number;
  @Input() annualPriceForCurrent?: number;
  @Input() demoUser?: boolean;
  public loading: boolean;
  public showCheckout: boolean = false;
  public visitors: string;
  public ssdStorage: string;
  public annualVisitors: string;
  public annualSsdStorage: string;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly _activeModal: DbActiveModal,
    private readonly _dialogService: DialogService,
    private readonly _router: Router,
    private readonly _googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this._getUserSubscriptionData();
  }

  private _getUserSubscriptionData(): void {
    const countPipe = new CountPipe();
    const sizePipe = new SizePipe();
    this.visitors = countPipe.transform(this.userSubscription.plan.services.hosting.hosting_visits.parameter_value);
    this.ssdStorage = sizePipe.transform(this.userSubscription.plan.services.hosting.hosting_storage.parameter_value * 1024 * 1024)
    this.annualVisitors = countPipe.transform(this.annualSubscription.plan.services.hosting.hosting_visits.parameter_value);
    this.annualSsdStorage = sizePipe.transform(this.annualSubscription.plan.services.hosting.hosting_storage.parameter_value * 1024 * 1024)
  }

  ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  public closeModal(isUpgraded = true): void {
    if (isUpgraded) {
      this._showSuccessfullyUpgradedDialog();
    }
    this._activeModal.close();
  }

  private _showSuccessfullyUpgradedDialog(): void {
    this._sendGaEvent();
    this._router.navigate(['/websites']);
    const shownText = this.userSubscription && this.userSubscription.isBusiness
      ? 'Congratulations! Your upgrade to the AI Ultimate Annual plan<br/> has been successfully processed.'
      : 'Congratulations! Your upgrade to the AI Ecommerce Premium Annual plan<br/> has been successfully processed.';
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: 'Successfully upgraded to an annual plan',
      message: shownText,
      width: 700,
      buttonText: 'Got It',
      buttonColor: 'black',
      buttonAlign: 'right',
      hasCloseButton: true,
      hasGradientBorder: true,
      textAlign: 'left'
    });
  }

  private _sendGaEvent(): void {
    const analyticsData = {
      eventCategory: 'Dashboard Action',
      eventAction: 'Upgrade to Annual flow',
      eventLabel: 'Checkout Completed'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

}
